export class VarianceReason {
    id: number;
    assignmentId: number;
    code: string;
    description: string;
    reason: string;
    default: boolean;
    deptLeaderPrompt: string;
    createdApplicationUserId: number;
    modifiedByUserName: string;
    modifiedDate: Date;
    errorMessage:string;
    order: number;
}
